import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import type {
  AgentGetFiatTransactionHistoryInput,
  AgentCalculateWithdrawalCostInput,
  AgentCancelWithdrawalFiatInput,
  AgentWithdrawFiatInput,
} from '../api'
import type { IMutationArgs } from '../types'
import {
  calculateAgentWithdrawalCostOptions,
  getAgentFiatTransactionHistoryOptions,
} from './agent-payment.options'
import userAgentPaymentService from './agent-payment.service'
import { EAgentPaymentQueryKey } from './agent-payment.types'
import { EAgentPortfolioQueryKey } from '../agent-portfolio'

export const useInitiateAgentWithdrawFiat = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: AgentWithdrawFiatInput) =>
      userAgentPaymentService.initiateAgentWithdrawalFiat(data),
    mutationKey: [EAgentPaymentQueryKey.INITIATE_WITHDRAW_FIAT],
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EAgentPaymentQueryKey.GET_FIAT_TRANSACTION_HISTORY],
        })
      queryClient.invalidateQueries({
        queryKey: [EAgentPortfolioQueryKey.AGENT_PORTFOLIO],
      })
      return data
    },
  })
}

export const useGetAgentFiatTransactionHistory = (
  args: AgentGetFiatTransactionHistoryInput,
) => {
  return useInfiniteQuery(getAgentFiatTransactionHistoryOptions(args))
}

export const useCalculateAgentWithdrawalCost = (
  args: AgentCalculateWithdrawalCostInput,
) => {
  return useQuery(calculateAgentWithdrawalCostOptions(args))
}

export const useCancelAgentWithdrawalFiat = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: AgentCancelWithdrawalFiatInput) =>
      userAgentPaymentService.cancelAgentWithdrawalFiat(data),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EAgentPaymentQueryKey.GET_FIAT_TRANSACTION_HISTORY],
        })
      queryClient.invalidateQueries({
        queryKey: [EAgentPortfolioQueryKey.AGENT_PORTFOLIO],
      })
      return data
    },
  })
}
